<template>
	<v-container pa-0 d-flex justify-center full-width>
		<v-layout justify-center column style="max-width: 600px">
			<div class="d-flex align-center full-width">
				<v-layout class="full-width" @click="modal = true">
					<v-dialog
						ref="dialog"
						v-model="modal"
						:return-value.sync="startDate"
						persistent
						width="270px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-flex class="px-1">
								<v-text-field
									v-model="displayStartDate"
									label="Select Start Date"
									v-bind="attrs"
									v-on="on"
									prepend-icon="today"
									placeholder="Select Start Date"
									class="text-field-wrapper pt-4"
								></v-text-field>
							</v-flex>
						</template>
						<v-date-picker
							v-model="startDate"
							:show-current="false"
							no-title
							elevation="15"
							:color="themeInputColor"
							class="btn"
							min="2021-08-03"
							width="270px"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								:color="themeInputColor"
								class="btn white--text"
								@click="modal = false"
							>
								Cancel
							</v-btn>
							<v-btn
								text
								:color="themeInputColor"
								class="btn white--text"
								@click="() => setDate(true)"
							>
								OK
							</v-btn>
						</v-date-picker>
					</v-dialog>
				</v-layout>
				<div>TO</div>
				<v-layout
					class="full-width"
					@click="endDateModal = !!startDate"
				>
					<v-dialog
						ref="endDateDialog"
						v-model="endDateModal"
						:return-value.sync="endDate"
						persistent
						width="270px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-flex class="px-1">
								<v-text-field
									v-model="displayEndDate"
									label="Select End Date"
									v-bind="attrs"
									v-on="on"
									prepend-icon="today"
									placeholder="Select End Date"
									class="text-field-wrapper pt-4"
									:disabled="!startDate"
								></v-text-field>
							</v-flex>
						</template>
						<v-date-picker
							v-model="endDate"
							:show-current="false"
							no-title
							elevation="15"
							:color="themeInputColor"
							class="btn"
							:min="startDate"
							:max="addDaysToDate(startDate, 59)"
							:disabled="!startDate"
							width="270px"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								:color="themeInputColor"
								class="btn white--text"
								@click="endDateModal = false"
							>
								Cancel
							</v-btn>
							<v-btn
								text
								:color="themeInputColor"
								class="btn white--text"
								@click="() => setDate(false)"
							>
								OK
							</v-btn>
						</v-date-picker>
					</v-dialog>
				</v-layout>
			</div>
			<v-flex
				class="border-4 grey darken-1 white--text mt-2 pa-2 text-center"
				v-if="
					(!isRummyOptionSelected && isOldRetailScheme) ||
						(isRummyOptionSelected && isOldRetailSchemeCardGames)
				"
			>
				<div class="font-weight-bold">DISCLAIMER</div>
				<div>
					This data is for comparision purpose only. No payments will
					be made corresponding to the values shown.
				</div>
			</v-flex>
			<v-flex
				class="border-4 white--text mt-2 pa-4"
				:style="{ backgroundColor: themeInputColor }"
			>
				<div class="big-font">Total Commission Earned</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{
						commissionComparison.newModel
							.toFixed(2)
							.toLocaleString()
					}}
					<span class="body-2 pl-1">
						( GST/TDS - <span>&#8377;</span
						>{{
							(
								+commissionComparison.newModel -
								+commissionComparison.newModel / 1.13
							)
								.toFixed(2)
								.toLocaleString()
						}}
						)
					</span>
				</div>
				<div class="big-font">Total GMV</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ dstrTotalGmv.toFixed(2).toLocaleString() }}
				</div>
				<div class="big-font pt-2">Self Commission Earned</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ totalCommissionEarned.toFixed(2).toLocaleString() }}
				</div>
				<div class="big-font pt-2">Self GMV</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ dstrSelfGmv.toFixed(2).toLocaleString() }}
				</div>
			</v-flex>
			<v-flex
				class="border-4 gradient-bg white--text mt-2 py-3 px-4"
				v-if="
					(!isRummyOptionSelected && isOldRetailScheme) ||
						(isRummyOptionSelected && isOldRetailSchemeCardGames)
				"
			>
				<div class="bigger-font d-flex justify-center align-center">
					Commission Comparison
				</div>
				<div
					class="big-font d-flex justify-space-between align-center pt-2"
				>
					<div class="max-w-fit-content">
						Old Model
					</div>
					<div class="max-w-fit-content">
						New Model
					</div>
				</div>
				<div
					class="big-font d-flex justify-space-between align-center pt-2"
				>
					<div class="bigger-font max-w-fit-content">
						<span class="bigger-font">&#8377;</span>
						{{ getReadableAmount(+commissionComparison.oldModel) }}
						<div class="body-1">
							GST - <span>&#8377;</span
							>{{
								getReadableAmount(
									+commissionComparison.oldModel -
										+commissionComparison.oldModel / 1.13
								)
							}}
						</div>
					</div>
					<div
						class="headline max-w-fit-content"
						:style="
							commissionComparison.newModel -
								commissionComparison.oldModel >=
							0
								? { color: '#75EFC6' }
								: { color: '#FFAAB1' }
						"
					>
						<span class="bigger-font">
							{{
								commissionComparison.newModel -
									commissionComparison.oldModel >=
								0
									? "&#43;"
									: "&#8722;"
							}}</span
						>
						{{
							getReadableAmount(
								+Math.abs(
									commissionComparison.newModel -
										commissionComparison.oldModel
								)
							)
						}}
					</div>
					<div class="bigger-font max-w-fit-content">
						<span class="bigger-font">&#8377;</span>
						{{ getReadableAmount(+commissionComparison.newModel) }}
						<div class="body-1">
							GST - <span>&#8377;</span
							>{{
								getReadableAmount(
									+commissionComparison.newModel -
										+commissionComparison.newModel / 1.13
								)
							}}
						</div>
					</div>
				</div>
			</v-flex>
			<div>
				<div
					v-if="(retailerEntries || []).length > 0"
					class="tableContainer"
				>
					<div class="tableHeader">
						<div>Retailer</div>
						<div>GMV</div>
						<div>Commission</div>
					</div>
					<div
						class="bg"
						v-infinite-scroll="fetchRetailerEntries"
						infinite-scroll-disabled="disableInfiniteLoading"
						infinite-scroll-distance="200"
						infinite-scroll-throttle-delay="200"
					>
						<template v-for="(item, index) in retailerEntries">
							<div :key="index" class="listEntry">
								<div class="entryInfo">
									<div>
										<div
											class="bigger-font blue--text text--darken-4"
										>
											{{ item.name }}
										</div>
										<div class="overline pt-1">
											{{ item.phoneNo }}
										</div>
									</div>
									<div class="entryMoney">
										<div
											class="title light-blue--text text--darken-4"
										>
											₹{{
												item.gmv
													.toFixed(2)
													.toLocaleString()
											}}
										</div>
									</div>
									<div class="entryMoney">
										<div
											class="title light-blue--text text--darken-4"
										>
											₹{{
												item.commission
													.toFixed(2)
													.toLocaleString()
											}}
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
import { MONTHS, RUMMY_COLOUR, THEME_INPUT_COLOUR } from "../../constants";
import {
	FETCH_DISTRIBUTOR_COMMISION,
	FETCH_DSTR_RETAILERS_COMMISSION
} from "../../../store/action-types";
import { mapState } from "vuex";
import { getReadableAmount } from "../../../utils";
import infiniteScroll from "vue-infinite-scroll";
import { END, TOP } from "../../../store/config";

export default {
	data() {
		return {
			modal: false,
			endDateModal: false,
			startDate: new Date().toISOString().substr(0, 10),
			endDate: new Date().toISOString().substr(0, 10),
			displayStartDate: "",
			displayEndDate: "",
			MONTHS: MONTHS,
			disableInfiniteLoading: false,
			getReadableAmount
		};
	},
	directives: { infiniteScroll },
	methods: {
		fetchRetailerEntries(type = END) {
			if (!this.disableInfiniteLoading || type === TOP) {
				if (!this.startDate || !this.endDate) return;
				this.disableInfiniteLoading = true;
				this.$store
					.dispatch(FETCH_DSTR_RETAILERS_COMMISSION.dispatch, {
						startDate: this.startDate,
						endDate: this.addDaysToDate(this.endDate, 1),
						type,
						isRummyOptionSelected: this.isRummyOptionSelected
					})
					.catch(() => {})
					.then(() => {
						this.disableInfiniteLoading = !this.nextOffset;
					});
			}
		},
		fetchDstrCommission() {
			this.$store.dispatch(FETCH_DISTRIBUTOR_COMMISION.dispatch, {
				startDate: this.startDate,
				endDate: this.addDaysToDate(this.endDate, 1),
				isRummyOptionSelected: this.isRummyOptionSelected
			});
		},
		getDateToDisplay(date) {
			const [stYear, stMonth, stDate] = date.split("-");
			return `${stDate} ${MONTHS[Number(stMonth) - 1].substr(
				0,
				3
			)} ${stYear.substr(2)}`;
		},
		setDate(isStartDate) {
			if (isStartDate) {
				this.$refs.dialog.save(this.startDate);
				this.displayStartDate = this.getDateToDisplay(this.startDate);
			} else {
				this.$refs.endDateDialog.save(this.endDate);
				this.displayEndDate = this.getDateToDisplay(this.endDate);
			}
			this.fetchRetailerEntries(TOP);
			this.fetchDstrCommission();
		},
		addDaysToDate(date, days) {
			if (!date) return "";
			const finalDate = new Date(
				new Date(date).setDate(new Date(date).getDate() + Number(days))
			);
			return finalDate.toISOString().substr(0, 10);
		}
	},
	mounted() {
		this.displayStartDate = this.getDateToDisplay(this.startDate);
		this.displayEndDate = this.getDateToDisplay(this.endDate);
		// this.fetchRetailerEntries(TOP);
		// this.fetchDstrCommission();
	},
	computed: {
		...mapState({
			totalCommissionEarned: state =>
				state.jeet11.distributorCommission.commissionEarned,
			commissionComparison: state =>
				state.jeet11.distributorCommission.dstrCommission,
			retailerEntries: state =>
				state.jeet11.distributorCommission.retailerEntries,
			dstrTotalGmv: state => state.jeet11.distributorCommission.totalGmv,
			dstrSelfGmv: state => state.jeet11.distributorCommission.selfGmv,
			nextOffset: state => state.jeet11.distributorCommission.nextOffset,
			isOldRetailScheme: state =>
				state.jeet11.jeet11PartnerDetails.retailScheme === "old",
			isOldRetailSchemeCardGames: state =>
				state.jeet11.jeet11PartnerDetails.gameRetailScheme === "old"
		}),
		themeInputColor() {
			return this.isRummyOptionSelected
				? RUMMY_COLOUR
				: THEME_INPUT_COLOUR;
		}
	},
	props: ["isRummyOptionSelected"]
};
</script>

<style scoped lang="scss">
.tableContainer {
	box-shadow: 0px 0px 8px rgba(7, 28, 80, 0.1);
}
.tableHeader {
	background: #edf0f7;
	display: flex;
	justify-content: space-between;
	padding: 8px 2em;
	font-size: 12px;
	color: #7b899e;
	margin-top: 3em;
}
.listEntry {
	display: flex;
	align-items: center;
	padding: 12px 8px 14px;
	border-bottom: 1px solid #ccc;
	position: relative;
}
.listEntry .sideElement {
	position: absolute;
	height: 100%;
	width: 5px;
	left: 0;
	top: 0;
	background: #205fb9;
}
.listEntry .sideElement.right {
	left: unset;
	right: 0;
}
.listEntry > div {
	display: flex;
	align-items: center;
}
.entryInfo {
	flex: 0 1 calc(100%);
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-inline: 1em;
	& > div:first-child > div:first-child {
		color: #575f6b;
		font-size: 14px;
	}
	& > div:first-child > div:last-child {
		color: #828a97;
		font-size: 12px;
	}
}
.entryMoney {
	font-size: 12px;
	display: flex;
	flex-direction: column;
	justify-content: right;
	direction: rtl;
	overflow-wrap: anywhere;
}
.big-font {
	font-size: 14px;
	font-weight: 500;
}
.bigger-font {
	font-size: 24px;
	font-weight: 500;
}
.huge-font {
	font-size: 30px;
	font-weight: 500;
}
.border-4 {
	border-radius: 4px;
}
.gradient-bg {
	background: linear-gradient(135deg, #5b247a 0%, #25b2ce 100%);
}
.max-w-fit-content {
	max-width: fit-content;
}
</style>
